import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en.json";
import jaTranslation from "./locales/ja.json";

i18n
  .use(LanguageDetector) // 启用自动检测
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ja: { translation: jaTranslation },
    },
    // 注意：有了 LanguageDetector，通常不需要设置 lng 属性
    // 如果检测不到（比如用户浏览器设置了非中英日语言），则使用 fallbackLng
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"], // 自动记住用户的选择
    },
  });

export default i18n;
